import { FC, memo, useEffect, useRef } from 'react'

import { useRouterState } from '@tanstack/react-router'

import { LeaveConfirmationContext } from './LeaveConfirmationContext'
import { LeaveConfirmationProps } from './LeaveConfirmationProps'
import { useLeaveConfirmation } from './hooks'

export const LeaveConfirmation: FC<LeaveConfirmationProps> = memo((props: LeaveConfirmationProps) => {
  const { preventLeaving, children, onLeave } = props
  const prevPreventLeavingRef = useRef(preventLeaving)
  const pathname = useRouterState({ select: (s) => s.location.pathname })
  const prevPathnameRef = useRef(pathname)

  const { showLeaveConfirmation } = useLeaveConfirmation(preventLeaving ?? false)

  useEffect(() => {
    const pathnameChanged = prevPathnameRef.current !== pathname
    const wasPreventing = prevPreventLeavingRef.current
    const isNotPreventingNow = !preventLeaving

    if (pathnameChanged && wasPreventing && isNotPreventingNow && onLeave) {
      onLeave()
    }

    prevPathnameRef.current = pathname
    prevPreventLeavingRef.current = preventLeaving
  }, [pathname, preventLeaving, onLeave])

  return (
    <LeaveConfirmationContext.Provider value={{ showLeaveConfirmation }}>{children}</LeaveConfirmationContext.Provider>
  )
})
